export default {
  header: 'Material',
  groupKey: 'material',
  filters: [
    { text: 'Aluminum', id: 'aluminum' },
    { text: 'Copper', id: 'copper' },
    { text: 'Iron', id: 'iron' },
    { text: 'Magnesium', id: 'magnesium' },
    { text: 'Nickel', id: 'nickel' },
    { text: 'Steel', id: 'steel' },
    { text: 'Titanium', id: 'titanium' },
    { text: 'Lead', id: 'lead' },
    { text: 'Cobalt', id: 'cobalt' },
    { text: 'Unspecified', id: 'unspecified' },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/materialFilters.js